module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-declaration"
  }, [_c('div', {
    staticClass: "jin-declaration_title"
  }, [_c('h5', [_c('i'), _vm._v(" "), _c('span', [_vm._v("美港电讯声明")])])]), _vm._v(" "), _c('div', {
    staticClass: "jin-declaration_b"
  }, [_c('p', [_vm._v("\n      美港电讯的数据解读是计算机自动获取并通过程序运算进行的理论性解读，不代表实际影响。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      我们会尽力保证数据发布速度与准确性，由于不可控因素导致数据未能及时发布敬请谅解。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      您或许看到有些数据延迟或提前发布，这是由于数据公布机构有时未必会准时发布所导致。\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d3e73a1","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Declatration.vue
// module id = PZeC
// module chunks = 2